module.exports = __webpack_public_path__ + "img/YiheLuo.41c57d4e.jpg";